if (!customElements.get('xt40-carousel')) {
  customElements.define('xt40-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      this.track = this.querySelector('.xw-track');
      this.prev = this.querySelector('[data-hot-prev]');
      this.next = this.querySelector('[data-hot-next]');
      const update = () => {
        const max = this.track.scrollWidth-this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.prev.disabled = position < 2;
        this.next.disabled = position >= max-2;
        this.querySelector('.xw-controls').hidden = max < 2;
      };
      const move = direction => this.track.scrollBy({left: direction*(this.track.clientWidth*.9),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      this.prev.addEventListener('click',()=>move(1),opts);
      this.next.addEventListener('click',()=>move(-1),opts);
      this.track.addEventListener('scroll',update,{...opts,passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.track);
      update();
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.ready=false;}
  });
}
if (!customElements.get('xt40-announcement')) {
  customElements.define('xt40-announcement',class extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.abort=new AbortController();
      const opts={signal:this.abort.signal};
      this.items=[...this.querySelectorAll('[data-message]')];
      this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.timer=setInterval(()=>{
        if(this.paused||document.hidden||this.matches(':hover')||this.contains(document.activeElement))return;
        this.items[this.index].hidden=true;
        this.index=(this.index+1)%this.items.length;
        this.items[this.index].hidden=false;
      },5000);
    }
    disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.ready=false;}
  });
}

